import * as React from 'react';
export const IcReplyAll = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11 9V7a2 2 0 00-1.23-1.85 2 2 0 00-2.18.44l-5 5a2 2 0 000 2.82l5 5a2 2 0 002.18.44A2 2 0 0011 17v-2c6.33 0 8.32 4.39 8.85 6.22a1.08 1.08 0 001 .78A1.09 1.09 0 0022 20.84C21.25 10.86 11 9 11 9zm2-2v.44a16.37 16.37 0 019 6.81v-.14c-.57-7.63-8.41-9-8.41-9V3.53A1.53 1.53 0 0011 2.45l-.76.76c.1 0 .21 0 .31.09A4 4 0 0113 7z'
      fill='currentColor'
    />
  </svg>
);
